import { Stack, styled } from '@mui/material';

import breakpoints from '../../../../constants/breakpoints';

type WrapperProps = {
  'data-is-fallback'?: boolean;
};

export const LabelsCreateWrapper = styled(Stack)<WrapperProps>(
  ({ 'data-is-fallback': isFallback = false, theme }) => ({
    alignItems: 'flex-end',
    paddingInline: 'var(--spacing-big)',
    ...(isFallback && {
      '& .MuiButton-root': {
        border: 'var(--border-darker)',
      },
      alignItems: 'center',
    }),
    [theme.breakpoints.down(breakpoints.tabletS)]: {
      '& .MuiButton-root': {
        border: 'var(--border-darker)',
      },
      paddingInline: 0,
    },
  }),
);

export const SectionWrapper = styled(Stack)(({ theme }) => ({
  height: '100%',
  overflow: 'hidden',
  [theme.breakpoints.up(breakpoints.mobileL)]: {},
}));
